import { type IBannerImage } from '..'

import { BannersTrackers } from 'services/tracker/events/Banners'

export const CAROUSEL_DEFAULT_CONFIGS = {
  key: 'autoplay-slide',
  autoplay: true,
  autoplaySpeed: 10000,
  infinite: true,
  speed: 500,
  centerMode: true,
}

export const CARROUSEL_CONTENT: IBannerImage[] = [
  {
    image: `https://77solassets.s3.sa-east-1.amazonaws.com/banners/${process.env.REACT_APP_S3_PREFIX}/home/banner_1.png`,
    mobileImage: `https://77solassets.s3.sa-east-1.amazonaws.com/banners/${process.env.REACT_APP_S3_PREFIX}/home/banner_1_mobile.png`,
    largeImage: `https://77solassets.s3.sa-east-1.amazonaws.com/banners/${process.env.REACT_APP_S3_PREFIX}/home/banner_1_large.png`,
    url: '?financingModal',
    event: BannersTrackers.actions.clickOnBanner,
    bannerName: 'Financiamento: Nova tela chegou!',
    target: '_self',
  },
  {
    image: `https://77solassets.s3.sa-east-1.amazonaws.com/banners/${process.env.REACT_APP_S3_PREFIX}/home/banner_2.png`,
    mobileImage: `https://77solassets.s3.sa-east-1.amazonaws.com/banners/${process.env.REACT_APP_S3_PREFIX}/home/banner_2_mobile.png`,
    largeImage: `https://77solassets.s3.sa-east-1.amazonaws.com/banners/${process.env.REACT_APP_S3_PREFIX}/home/banner_2_large.png`,
    url: '?financingModal',
    event: BannersTrackers.actions.clickOnBanner,
    bannerName: 'Parceria: 77Sol + SolAgora',
    target: '_self',
  },
  {
    image: `https://77solassets.s3.sa-east-1.amazonaws.com/banners/${process.env.REACT_APP_S3_PREFIX}/home/banner_3.png`,
    mobileImage: `https://77solassets.s3.sa-east-1.amazonaws.com/banners/${process.env.REACT_APP_S3_PREFIX}/home/banner_3_mobile.png`,
    largeImage: `https://77solassets.s3.sa-east-1.amazonaws.com/banners/${process.env.REACT_APP_S3_PREFIX}/home/banner_3_large.png`,
    url: '?quotationModal',
    event: BannersTrackers.actions.clickOnBanner,
    bannerName: 'Nova proposta: A nova proposta da 77 é para você.',
    target: '_self',
  },
]
